import React, { useEffect, useRef, useState } from "react";
import Layout from "../../layout/DefaultLayout";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Card,
  Spinner,
} from "react-bootstrap";
import { FaArrowRight } from "react-icons/fa";
import { useNavigate, Link, useLocation } from "react-router-dom";
import Footer from "../../components/Footer";
import { useQuery, useMutation } from "react-query";
import api from "../../utils/helper";
import { useForm } from "react-hook-form";
import { useAlerts } from "../../context/AlertContext";
import { useAuth } from "../../context/AuthContext";
import { useIDsContext } from "../../context/IDsContext";
import { BadgesComponent } from "../../components/AddBadge";
import { URLS } from "../../utils/URL";

const AddCourse = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const fileInputRef = useRef(null);
  const { showSuccess, showError } = useAlerts();
  const { setCourseID, setVendorID } = useIDsContext();
  const { userID, userRole } = useAuth();
  const isEdit = location.state?.isEdit || false;
  const courseData = location.state?.course || {};

  const [tags, setTags] = useState([]);
  const [tagInput, setTagInput] = useState("");
  const [dataToNavigate, setDataToNavigate] = useState({});
  const [logoFile, setLogoFile] = useState(null);
  const [logoPreview, setLogoPreview] = useState(
    isEdit ? URLS.IMG_URL + courseData?.cover_img : null
  );
  const [thumbnailFile, setThumbnailFile] = useState(null);
  const [thumbnailPreview, setThumbnailPreview] = useState(
    isEdit ? URLS.IMG_URL + courseData?.thumbnail_img : null
  ); // for image preview
  const thumbnailInputRef = useRef(null); // to trigger input programmatically
  const [isLessonAddEnabled, setIsLessonAddEnabled] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
  } = useForm();

  useEffect(() => {
    console.log(courseData?.vendor, "vendor");
    if (isEdit && courseData) {
      setValue("name", courseData.name);
      setValue("vendor", courseData?.vendor?._id);
      setValue("duration", courseData.duration);
      setValue("about", courseData.about);

      // Set tags
      if (courseData.tags) {
        setTags(courseData.tags);
      }

      // Set logo preview if exists
      if (courseData.cover_img) {
        setLogoPreview(URLS.IMG_URL + courseData.cover_img);
      }
      if (courseData.thumbnail_img) {
        setThumbnailPreview(URLS.IMG_URL + courseData.thumbnail_img);
      }
    }
  }, [isEdit, courseData, setValue]);

  const { data, isLoading: vendorsLoading } = useQuery(
    ["vendors", "/super-admin/vendors"],
    () => api.get("/super-admin/vendors").then((res) => res.data.data),
    {
      enabled: !!courseData, // This ensures the API call happens only when courseData is available
    }
  );

  const vendors = data || [];

  const handleTagInput = (e) => {
    if (e.key === "Enter" && tagInput.trim()) {
      e.preventDefault();
      if (!tags.includes(tagInput.trim())) {
        setTags([...tags, tagInput.trim()]);
        setTagInput("");
      }
    }
  };

  const removeTag = (tag) => {
    setTags(tags.filter((t) => t !== tag));
  };

  const handleAddLesson = () => {
    setCourseID(dataToNavigate._id || courseData._id);
    setVendorID(dataToNavigate.vendor || courseData?.vendor?._id);
    navigate("/add-leason", {
      state: { dataToNavigate: dataToNavigate || courseData?.vendor },
    });
  };

  const handleDivClick = () => {
    fileInputRef.current.click(); // Trigger file input click
  };

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setLogoFile(file);
      const reader = new FileReader();
      reader.onload = () => {
        setLogoPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleThumbnailChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setThumbnailFile(file);
      const reader = new FileReader();
      reader.onload = () => {
        setThumbnailPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  useEffect(() => {
    if (isEdit && courseData) {
      // Other form value initialization logic
      if (courseData.thumbnail_img) {
        setThumbnailPreview(URLS.IMG_URL + courseData.thumbnail_img); // Set thumbnail preview if in edit mode
      }
    }
  }, [isEdit, courseData]);

  // const courseUpdateMutation = useMutation(
  //   (updateData) => api.put(`/courses/${courseData._id}`, updateData),
  //   {
  //     onSuccess: (response) => {
  //       showSuccess(response.data?.message || "Course updated successfully!");
  //       navigate("/courses");
  //     },
  //     onError: (error) => {
  //       showError(
  //         error.response?.data?.message ||
  //         "Failed to update course. Please try again."
  //       );
  //     },
  //   }
  // );

  // const addCourseMutation = useMutation(
  //   (courseData) => api.post("/courses", courseData),
  //   {
  //     onSuccess: (response) => {
  //       showSuccess(response.data?.message || "Course added successfully!");
  //       setDataToNavigate(response.data?.data);
  //       setIsLessonAddEnabled(true);

  //       reset();
  //       setTags([]);
  //     },
  //     onError: (error) => {
  //       showError(
  //         error.response?.data?.message ||
  //         "Failed to add course. Please try again."
  //       );
  //       setIsLessonAddEnabled(false);
  //     },
  //   }
  // );

  const uploadMutation = useMutation(
    ({ formData }) => api.upload("/upload", formData, "upload"),
    {
      onSuccess: (response, variables) => {
        const updatedFormInputs = {
          ...variables.courseData,
          ...(response?.data?.data?.url && {
            cover_img: response.data.data.url,
            thumbnail_img: response.data.data.url,
          }),
          // cover_img: response?.data?.data?.url,
        };

        // Choose between update or add mutation based on edit mode
        if (isEdit) {
          courseUpdateMutation.mutate(updatedFormInputs);
        } else {
          addCourseMutation.mutate(updatedFormInputs);
        }
      },
      onError: (error) => {
        showError(error?.response?.data?.message || "Error uploading file:");
        console.error("Error uploading file:", error);
      },
    }
  );

  // const onSubmit = (data) => {
  //   const courseInputData = {
  //     ...data,
  //     type: "contextual",
  //     tags: tags,
  //     createdBy: { role: userRole, user: userID },
  //     ...(isEdit &&
  //       !logoFile &&
  //       courseData.cover_img && { cover_img: courseData.cover_img }),
  //   };

  //   if (!logoFile) {
  //     if (isEdit) {
  //       courseUpdateMutation.mutate(courseInputData);
  //     } else {
  //       addCourseMutation.mutate(courseInputData);
  //     }
  //     return;
  //   }

  //   const formData = new FormData();
  //   formData.append("file", logoFile);
  //   formData.append("courseName", "course");
  //   formData.append("moduleName", "course");

  //   uploadMutation.mutate({ formData, courseData: courseInputData });
  // };

  // Update the onSubmit function to handle both image uploads
  const onSubmit = async (data) => {
    try {
      const courseInputData = {
        ...data,
        type: "contextual",
        tags: tags,
        createdBy: { role: userRole, user: userID },
      };

      // Retain existing URLs in edit mode if no new files are uploaded
      if (isEdit) {
        if (!logoFile && courseData.cover_img) {
          courseInputData.cover_img = courseData.cover_img;
        }
        if (!thumbnailFile && courseData.thumbnail_img) {
          courseInputData.thumbnail_img = courseData.thumbnail_img;
        }
      }

      // Upload cover image if a new file is provided
      if (logoFile) {
        courseInputData.cover_img = await uploadFile(logoFile);
      }

      // Upload thumbnail image if a new file is provided
      if (thumbnailFile) {
        courseInputData.thumbnail_img = await uploadFile(thumbnailFile);
      }

      // Submit the course data
      if (isEdit) {
        await courseUpdateMutation.mutateAsync(courseInputData);
        showSuccess("Course updated successfully!");
        navigate("/courses");
      } else {
        const response = await addCourseMutation.mutateAsync(courseInputData);
        showSuccess("Course added successfully!");
        setDataToNavigate(response.data?.data);
        setIsLessonAddEnabled(true);
        reset();
        setTags([]);
      }
    } catch (error) {
      showError(
        error.response?.data?.message ||
        "Failed to save course. Please try again."
      );
    }
  };

  const uploadFile = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("courseName", "course");
    formData.append("moduleName", "course");
    const response = await api.upload("/upload", formData, "upload");
    return response.data.data.url;
  };

  const courseUpdateMutation = useMutation((updateData) =>
    api.put(`/courses/${courseData._id}`, updateData)
  );

  const addCourseMutation = useMutation((courseData) =>
    api.post("/courses", courseData)
  );

  return (
    <Layout>
      <div className="bgNav d-block d-lg-none pb-5 px-1 position-relative">
        <div>
          <h2 className="heading mb-0 px-3">
            <Link to="/courses" className="linkHref">
              <span className="linkHref">Courses</span>
            </Link>{" "}
            <Link to="/courses" className="linkHref">
              <span className="linkHref">
                {" "}
                <FaArrowRight /> Contextual
              </span>
            </Link>{" "}
            <span className=" text-light fw-bold">
              {" "}
              <FaArrowRight className="mx-1" /> {isEdit ? "Edit" : "Add New"}
            </span>
          </h2>
        </div>
        <div className="d-flex justify-content-center px-2 mt-3">
          <Button
            variant="light"
            className="me-2 btn-course"
            onClick={() => navigate("/courses")}
          >
            Cancel
          </Button>

          <Button
            variant="light"
            className="me-2 btn-course"
            disabled={
              addCourseMutation.isLoading ||
              courseUpdateMutation.isLoading
            }
            onClick={handleSubmit(onSubmit)}
          >
            Save Draft
          </Button>
        </div>
      </div>
      <Container
        fluid
        className="main-container vendor-container mt-0 mt-md-4 ps-auto ps-md-0"
      >
        <Card className="form-card">
          {/* Header Section */}
          <Card.Header className="heading d-none d-lg-block">
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex gap-2 align-items-center">
                <h2 className="venhead mb-0">
                  <Link to="/courses" className="linkHref">
                    <span>Courses</span>
                  </Link>{" "}
                  <Link to="/courses" className="linkHref">
                    <span>
                      {" "}
                      <FaArrowRight /> Contextual
                    </span>
                  </Link>{" "}
                  <span className="venhead">
                    {" "}
                    <FaArrowRight /> {isEdit ? "Edit" : "Add New"}
                  </span>
                </h2>
              </div>
              <div>
                <Button
                  variant="outline-secondary"
                  className="me-2 btn-sec"
                  onClick={() => navigate("/courses")}
                >
                  Cancel
                </Button>

                <Button
                  variant="outline-secondary"
                  className="me-2 btn-sec"
                  onClick={handleSubmit(onSubmit)}
                  disabled={
                    addCourseMutation.isLoading ||
                    courseUpdateMutation.isLoading
                  }
                >
                  Save Draft
                </Button>
              </div>
            </div>
          </Card.Header>
          <Card.Body className="mobile-form">
            {/* Form Section */}
            <Row className="mb-3">
              <Col md={3} className="px-4 py-2 p-md-2">
                <h3 className="vendorDetails">Basic Course Details</h3>
                <p className="basicInfo">
                  {isEdit ? "Update course" : "Add course"}'s basic info
                </p>
              </Col>
              <Col md={9}>
                <Form
                  className="p-3 formMain"
                  onSubmit={handleSubmit(onSubmit)}
                >
                  {/* Course Name */}
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Course Name <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter course name"
                      {...register("name", {
                        required: "Course name is required",
                      })}
                      isInvalid={!!errors.name}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.name?.message}
                    </Form.Control.Feedback>
                  </Form.Group>

                  {/* Upload Logo */}
                  <Form.Group className="mb-3 d-flex justify-content-between">
                    <div className="p-con d-flex gap-4 p-2 w-50">
                      <div
                        className="text-center w-100"
                        onClick={() => thumbnailInputRef?.current?.click()}
                        style={{ cursor: "pointer" }}
                      >
                        <img
                          src={thumbnailPreview || "/images/uploadIcon.png"}
                          className="icon-upload"
                          alt="Upload"
                        />
                        <p className="upload-text mb-0">
                          <span>Click to upload</span> or drag and drop
                        </p>
                        <p className="text-muted upload-text-small mb-0">
                          SVG, PNG, JPG or GIF (max. 400x400px)
                        </p>
                        <Form.Control
                          type="file"
                          accept="image/*"
                          className="d-none"
                          ref={thumbnailInputRef}
                          onChange={handleThumbnailChange}
                        />
                      </div>

                      {/* Thumbnail Image Upload */}
                      {/* <div
                        className="text-center w-100"
                        onClick={() => thumbnailInputRef?.current?.click()}
                        style={{ cursor: "pointer" }}
                      >
                        <img
                          src={thumbnailPreview || "/images/uploadIcon.png"}
                          className="icon-upload"
                          alt="Upload"
                        />
                        <Form.Control
                          type="file"
                          accept="image/*"
                          className="d-none"
                          ref={thumbnailInputRef}
                          onChange={handleThumbnailChange}
                        />
                      </div> */}
                    </div>
                    <div className="p-con d-flex gap-4 p-2 w-50">
                      <div
                        className="text-center w-100"
                        onClick={handleDivClick}
                        style={{ cursor: "pointer" }}
                      >
                        <img
                          src={logoPreview || "/images/uploadIcon.png"}
                          className="icon-upload"
                          alt="Upload"
                        />
                        <p className="upload-text mb-0">
                          <span>Click to upload</span> or drag and drop
                        </p>
                        <p className="text-muted upload-text-small mb-0">
                          SVG, PNG, JPG or GIF (max. 800x400px)
                        </p>
                        <Form.Control
                          type="file"
                          accept="image/*"
                          className="d-none"
                          ref={fileInputRef}
                          onChange={handleLogoChange}
                        />
                      </div>

                      {/* <div
                        className="text-center w-100"
                        onClick={handleDivClick}
                        style={{ cursor: "pointer" }}
                      >
                        <img
                          src={logoPreview || "/images/uploadIcon.png"}
                          className="icon-upload"
                          alt="Upload"
                        />
                        <Form.Control
                          type="file"
                          accept="image/*"
                          className="d-none"
                          ref={fileInputRef}
                          onChange={handleLogoChange}
                        />
                      </div> */}
                    </div>
                  </Form.Group>

                  {/* Tags */}
                  <Form.Group className="mb-3" controlId="multiSelect">
                    <Form.Label>
                      Add Tags <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Tags"
                      value={tagInput}
                      onChange={(e) => setTagInput(e.target.value)}
                      onKeyDown={handleTagInput}
                    />
                    <div className="mt-2">
                      <BadgesComponent badges={tags} removeTag={removeTag} />
                    </div>
                  </Form.Group>

                  {/* Vendor */}
                  <Form.Group controlId="selectVendor" className="mb-4">
                    <Form.Label className="drpvendor">
                      Select Vendor <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select
                      {...register("vendor", {
                        required: "Vendor is required",
                      })}
                      isInvalid={!!errors.vendor}
                      disabled={vendorsLoading}
                    >
                      <option value="">Select a vendor</option>
                      {vendors.length > 0 ? (
                        vendors.map(
                          ({ vendor }) =>
                            vendor && (
                              <option key={vendor._id} value={vendor._id}>
                                {vendor.name}
                              </option>
                            )
                        )
                      ) : (
                        <option disabled>No vendors available</option>
                      )}
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      {errors.vendor?.message}
                    </Form.Control.Feedback>
                  </Form.Group>

                  {/* Duration */}
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Duration <span>(In Days)</span>{" "}
                      <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="number"
                      placeholder="30"
                      {...register("duration", {
                        required: "Duration is required",
                      })}
                      isInvalid={!!errors.duration}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.duration?.message}
                    </Form.Control.Feedback>
                  </Form.Group>

                  {/* About */}
                  <Form.Group className="mb-3">
                    <Form.Label>
                      About <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      {...register("about", {
                        required: "About course is required",
                      })}
                      isInvalid={!!errors.about}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.about?.message}
                    </Form.Control.Feedback>
                  </Form.Group>

                  {/* Continue Button */}
                  <div className="text-end d-flex justify-content-end">
                    <Button
                      type="submit"
                      color="#60B1FF"
                      className="btn-sec me-2"
                      disabled={
                        addCourseMutation.isLoading ||
                        courseUpdateMutation.isLoading
                      }
                    >
                      {(addCourseMutation.isLoading ||
                        courseUpdateMutation.isLoading) && (
                          <Spinner size="sm" className="me-2" />
                        )}
                      {isEdit ? "Update" : "Save"} Course
                    </Button>

                    <Button
                      color="#60B1FF"
                      className="btn-sec"
                      onClick={handleAddLesson}
                      disabled={!isEdit && !isLessonAddEnabled}
                    >
                      {isEdit ? "Update" : "Add"} Lesson
                      <FaArrowRight className="ms-2" />
                    </Button>
                  </div>
                </Form>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Container>
      <div className="d-none d-lg-block">
        <Footer />
      </div>
    </Layout>
  );
};

export default AddCourse;
